type LogoProps = {
  width: number
  color?: string
}

export default function Logo({ width, color = '#2E2727' }: LogoProps) {
  const ratio = 135 / 80
  const height = width / ratio

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 135 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M134.5 39.949C134.5 50.7325 127.112 60.584 114.975 67.7669C102.85 74.9432 86.0658 79.398 67.5 79.398C48.9342 79.398 32.1504 74.9432 20.025 67.7669C7.88843 60.584 0.5 50.7325 0.5 39.949C0.5 29.1654 7.88843 19.3139 20.025 12.1311C32.1504 4.95477 48.9342 0.5 67.5 0.5C86.0658 0.5 102.85 4.95477 114.975 12.1311C127.112 19.3139 134.5 29.1654 134.5 39.949Z"
        stroke={color}
      />
      <path
        d="M82.6531 20.6633H67.5V55.102H82.6531V39.949L104.694 55.102H121.224L97.8061 35.8163L118.469 20.6633H104.694L82.6531 35.8163V20.6633Z"
        fill={color}
      />
      <path
        d="M38.5714 20.6633H60.6122V26.1735H38.5714L32 28.5L26.1735 31.6837L23.4184 35.8163V39.949V44.0816L26.1735 48.2143L32 51H38.5714H60.6122V55.102H33.0612H26.1735L16.5306 52.3469L11.5 48.2143L9.64285 44.0816V35.8163L15.5 28L26.1735 22.5L38.5714 20.6633Z"
        fill={color}
      />
      <path
        d="M82.6531 20.6633H67.5V55.102H82.6531V39.949L104.694 55.102H121.224L97.8061 35.8163L118.469 20.6633H104.694L82.6531 35.8163V20.6633Z"
        stroke={color}
      />
      <path
        d="M38.5714 20.6633H60.6122V26.1735H38.5714L32 28.5L26.1735 31.6837L23.4184 35.8163V39.949V44.0816L26.1735 48.2143L32 51H38.5714H60.6122V55.102H33.0612H26.1735L16.5306 52.3469L11.5 48.2143L9.64285 44.0816V35.8163L15.5 28L26.1735 22.5L38.5714 20.6633Z"
        stroke={color}
      />
    </svg>
  )
}

export function CkdLogo({ width, color = '#2E2727' }: LogoProps) {
  const ratio = 170 / 65
  const height = width / ratio

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 45.310733 17.128276"
      version="1.1"
      id="svg10012"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="layer2" transform="translate(-10.107801,-3.7173947)">
        <path
          fill={color}
          d="m 23.870032,4.0040054 -2.002002,0.077 -1.771002,0.077 -2.156003,0.3080007 -1.232002,0.3080004 -2.079003,0.9240012 -1.001001,0.4620006 -1.232002,0.847001 -1.078001,1.4630022 -0.693001,1.4630021 -0.308001,2.0790034 -0.077,1.540002 0.385001,1.771002 0.616001,1.309002 0.847001,1.155001 1.386002,1.155002 1.386001,0.847001 1.540003,0.539001 0.770001,0.154 11.473016,0.077 0.847,-16.4780227 h -3.388004 l -0.847001,14.1680197 -5.775008,0.154001 -1.335553,-0.318621 -1.128451,-0.451381 -1.386001,-0.847001 -0.847002,-1.155001 -0.693001,-1.386002 -0.231,-1.617003 0.462001,-2.079002 0.847001,-1.3860026 1.540002,-1.4630019 1.848003,-0.7700013 1.771002,-0.3850005 3.234004,-0.1540002 z"
          id="path1"
        />
        <path
          fill={color}
          d="m 39.732054,4.0040054 h -4.158005 l -6.160008,7.9310106 6.083009,8.470012 4.004006,0.077 -0.154001,-0.770001 -6.083009,-7.854011 z"
          id="path2"
        />
        <path
          id="path3"
          fill={color}
          d="m 48.279224,3.8498942 -8.316288,0.076998 -0.30799,16.7090658 9.471255,0.07699 1.770963,-0.769985 1.154956,-0.923969 1.46296,-1.46296 0.923975,-1.616955 0.769979,-2.232939 0.077,-2.309936 V 9.6252523 L 54.670048,7.8537842 53.438082,5.8518392 52.360112,4.8508667 51.205144,4.1578858 49.434192,3.8498942 Z m 0.077,2.3869345 1.616955,0.8469767 1.154969,1.308964 0.615983,1.6944706 0.230993,2.001945 -0.384989,1.616955 -0.538985,1.693954 -1.308964,1.462959 -0.769979,0.461988 -0.846977,0.461987 -1.000972,0.38499 -3.927409,0.077 0.230996,-12.0891931 z"
        />
      </g>
    </svg>
  )
}
